import React, { useRef, useState } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "../Navigation/Navigation.css";
import LogoNav from "../../assets/communityXlogo.svg";
import shoplocalAI from "../../assets/shoplocal AI.svg";
import userManual from "../../assets/User-Manual_Icon.svg";
// import UserImage from "../../assets/user.png";
import { Image, Row, Col } from "react-bootstrap";
import { BusinessInfoAPI } from "../../Utils/Api/UserProfile";
import {
  MdSearch,
  MdOutlineDashboard,
  MdOutlineAccountCircle,
  MdOutlineNotificationsNone,
  MdOutlineForum,
  MdLogout,
  MdOutlinePersonOutline,
  MdOutlineLocalAtm,
  MdOutlineModeEditOutline,
} from "react-icons/md";
import MyBusinessProfile from "../../assets/MyBusinessProfile.svg";
import { Link, useNavigate } from "react-router-dom";
import {
  GetSlUserName,
  getUser,
  removeUserCredentials,
  userId,
} from "../../Utils/LocalStorage";
import { useEffect } from "react";
import { StoreInfoAPI } from "../../Utils/Api/UserProfile";
import { useDispatch, useSelector } from "react-redux";
import EmailLink from "../../Components/EmailLink/EmailLink";
import { getUploadImageFlag } from "../../redux/costHistorySlice";
import { toast } from "react-toastify";
import { GetMappedBusinessList } from "../../Utils/Api/GetMappedBusinessList";
import { use } from "react";
import { Switch } from "antd";
import { SwitchBusinessUser } from "../../Utils/Api/SwitchBusinessUserApi";
import { setBusinessSwitched, setactiveBuId } from "../../Utils/LocalStorage";
import { CategoryList } from "./../../Utils/Api/CategoryList";
import { BusinessProfileAIAPI } from "./../../Utils/Api/BusinessProfileAIAPI";

const Navigation = () => {
  const navigate = useNavigate();
  const BuId = userId();
  const [activeStyle, setActiveStyle] = useState("");
  // const [profileImage, setProfileImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [idHeight, setIdHeight] = useState(0);
  const [navBarHeight, setNavBarHeight] = useState(0);
  const [BusinessList, setBusinessList] = useState([]);

  const userNameRef = useRef(null);
  const navBarRef = useRef(null);

  const updateHeight = () => {
    if (userNameRef.current) {
      setIdHeight(userNameRef.current.clientHeight);
    }
  };
  const updateNavHeight = () => {
    if (window.innerWidth <= 991 && navBarRef.current) {
      setNavBarHeight(navBarRef.current.clientHeight);
    }
  };

  useEffect(() => {
    updateNavHeight();
    updateHeight();
    window.addEventListener("resize", updateHeight);
    window.addEventListener("resize", updateNavHeight);
    return () => {
      window.removeEventListener("resize", updateHeight);
      window.removeEventListener("resize", updateNavHeight);
    };
  }, []);

  // independent-pages
  const [BusinessSlug, setBusinessSlug] = useState("");
  const LogoutHandler = (e) => {
    e.preventDefault();
    removeUserCredentials();
    navigate("/");
    localStorage.removeItem("is_switched");
    localStorage.removeItem("Bu_user");
    localStorage.removeItem("CurrentBu_name");
    localStorage.removeItem("independentSlug");
    localStorage.removeItem("sessionId");
  };

  const fetchMappedBusinesses = async () => {
    setLoading(true);
    const Bu_userId = localStorage.getItem("Bu_userId");
    const payload = {
      primary_bu_id: Bu_userId, // make dynamic later
    };

    const res = await GetMappedBusinessList(payload, () => navigate("/"));

    if (res && Array.isArray(res.data)) {
      setBusinessList(res.data);
    }
  };

  useEffect(() => {
    fetchMappedBusinesses();
  }, []);

  //get business info data
  const GetMyProfileBusinessInfo = async () => {
    const BusinessData = getUser();
    const Bu_userId = BusinessData ? BusinessData.user_id : "";
    const data = { bu_id: parseInt(Bu_userId), api_method: "get" };

    const MyProfileInfoData = await BusinessInfoAPI(data);

    if (MyProfileInfoData.status === 200) {
      // set it into local storage Bu_user
      localStorage.setItem(
        "CurrentBu_name",
        MyProfileInfoData.data[0].business_name,
      );
    }
  };

  const dispatch = useDispatch();

  const Reduxdata = useSelector((state) => state.costHistory);
  const UploadImageFlag = Reduxdata.UploadImage;

  // console.log(Reduxdata);

  const StoreImage = localStorage.getItem("ProfileImage");

  // console.log(activeStyle);

  const BusinessUserData = getUser();
  const SlUserName = GetSlUserName();
  const Bu_Name = BusinessUserData
    ? BusinessUserData.business_name
    : SlUserName;

  const NavbarHandler = (index) => {
    // console.log("gg");
    if (index == 3) {
      setActiveStyle("dashboard");
    }
    if (index == 4) {
      setActiveStyle("myaccout");
    }
    if (index == 5) {
      setActiveStyle("notifications");
    }
    if (index == 6) {
      setActiveStyle("messages");
    }
  };

  const ProfileImageHandler = async () => {
    const data = {
      bu_id: parseInt(BuId),
      api_method: "get",
    };
    const ProfileImageRes = await StoreInfoAPI(data);
    if (ProfileImageRes === false) {
      // navigate("*");
    } else if (ProfileImageRes.status === 429) {
      setLoading(true);
      toast.error(ProfileImageRes.message, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } else {
      // setProfileImage(ProfileImageRes.Data[0].store_thumbnail);
      const ProfileImage = ProfileImageRes?.Data[0]?.store_thumbnail
        ? ProfileImageRes?.Data[0]?.store_thumbnail
        : "";
      localStorage.setItem("ProfileImage", ProfileImage);
    }
  };

  useEffect(() => {
    const bu_slug = localStorage.getItem("independentSlug");
    setBusinessSlug(bu_slug);

    const path = window.location.href;
    const endPath = path.split("/");
    //
    if (endPath[3] === "dashboard") {
      setActiveStyle("dashboard");
    }
    if (endPath[3] === "my-account") {
      setActiveStyle("myaccout");
    }
    if (endPath[3] === "messages") {
      setActiveStyle("messages");
    }
    if (endPath[3] === "notifications") {
      setActiveStyle("notifications");
    }
    if (endPath[3] === "transactions") {
      setActiveStyle("transactions");
    }
    if (endPath[3] === "my-profile") {
      setActiveStyle("myprofile");
    }
    if (endPath[3] === "shop-local-AI") {
      setActiveStyle("shop-local-AI");
    }
    // if (endPath[3] === "mystorepoint") {
    //   setActiveStyle("mystorepoint");
    // }
  }, []);

  useEffect(() => {
    ProfileImageHandler();
    if (UploadImageFlag === true) {
      ProfileImageHandler();
      dispatch(getUploadImageFlag(false));
    }
  }, [UploadImageFlag]);

  const baseUrl = process.env.REACT_APP_MARKETPLACE_URL;
  const baseUrl1 = "http://localhost:3001/";

  const splitUsername = (str) => {
    let result = [];

    if (/^[^\s]+$/.test(str) || /\b\w{17,}\b/.test(str)) {
      for (let i = 0; i < str.length; i += 16) {
        let segment = str.slice(i, i + 16);
        if (segment.length === 16 && i + 16 < str.length) {
          segment += "-";
        }
        result.push(segment);
      }
    } else {
      result.push(str);
    }

    return result;
  };

  const formattedUsernames = splitUsername(Bu_Name);
  // console.log("formattedUsernames: ", formattedUsernames[0]);
  const currentBuName =
    localStorage.getItem("CurrentBu_name") == undefined ||
    localStorage.getItem("CurrentBu_name") == null
      ? formattedUsernames[0]
      : localStorage.getItem("CurrentBu_name");
  // console.log("currentBuName: ", currentBuName);

  // Switch business logic here
  const switchBusiness = async (businessEmail) => {
    if (!businessEmail) return;

    const payload = {
      bu_email: businessEmail,
    };

    const res = await SwitchBusinessUser(payload, () => navigate("/"));
    // console.log("Switch Business Response: ", res);

    if (res) {
      // Save new token
      localStorage.setItem("Bu_token", res.data.jwt_token);
      localStorage.setItem("independentSlug", res.data.business_slug);

      // to refresh the user business data after switching
      GetMyProfileBusinessInfo();

      toast.success("Business switched successfully", {
        theme: "dark",
        position: "top-center",
      });

      setBusinessSwitched(res.data.is_switched);
      setactiveBuId(res.data.active_business_id);

      //setBusinessSwitched(true);

      //  Redirect to dashboard
      navigate("/");
    }
  };

  const truncateSentence = (text, charLimit = 11) => {
    if (!text) return "";

    return text.length > charLimit ? text.slice(0, charLimit) + "..." : text;
  };

  return (
    <div className="navigation-wrapper" style={{ height: navBarHeight + 20 }}>
      <Navbar expand="lg" className="custom-nav-main mt-3" ref={navBarRef}>
        <div className="d-flex center_Div mt-4">
          <a href="/my-profile/general-info" className="signInsec">
            <Image loading="lazy" src={LogoNav} className="mx-3" />

            {formattedUsernames.map((segment, index) => (
              <div>
                <p className="mt-3 color_white signedAsText">Signed in as:</p>
                <p key={index} className="hyphenated color_white">
                  {segment}
                </p>
              </div>
            ))}
          </a>
        </div>

        <div className="select_business">
          {BusinessList.length > 1 ? (
            /*  SHOW DROPDOWN */ <>
              <p className="mt-3 color_white signedAsText">Active Business:</p>
              <select
                onChange={(e) => {
                  const selectedBusiness = e.target.value;
                  switchBusiness(selectedBusiness);
                }}
              >
                <option value="">Select Business</option>
                {BusinessList.map((bis, index) => (
                  <option
                    key={index}
                    value={bis.bu_email}
                    selected={bis.bi_name === currentBuName}
                  >
                    {truncateSentence(bis.bi_name, 15)}
                  </option>
                ))}
              </select>
            </>
          ) : (
            /* NO BUSINESS → SHOW NAME */
            <p></p>
          )}
        </div>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse
          id="basic-navbar-nav"
          className="custom-nav mt-1"
          style={{ height: `calc(100vh - (350px + ${idHeight}px))` }}
        >
          <Nav className="me-auto">
            <Link
              onClick={() => {
                NavbarHandler(3);
              }}
              to="/dashboard"
              className={
                activeStyle === "dashboard"
                  ? "nav-link nav-active"
                  : "nav-link mt-0"
              }
            >
              <MdOutlineDashboard className="nav-icon" />
              Dashboard
            </Link>
            <Link
              onClick={() => {
                NavbarHandler(4);
              }}
              to="/my-account/vouchers-dashboard"
              className={
                activeStyle === "myaccout"
                  ? "nav-link nav-active"
                  : "nav-link mt-0"
              }
            >
              <MdOutlineAccountCircle className="nav-icon" />
              My Account
            </Link>
            <Link
              onClick={() => {
                NavbarHandler(5);
              }}
              to="/notifications"
              className={
                activeStyle === "notifications"
                  ? "nav-link nav-active"
                  : "nav-link mt-0"
              }
            >
              <MdOutlineNotificationsNone className="nav-icon" />
              Notifications
            </Link>
            <Link
              onClick={() => {
                NavbarHandler(6);
              }}
              to="/messages/voucher_coupon"
              state={{
                productName: "Main Street Digital",
                businessName: "Main Street Digital",
              }}
              className={
                activeStyle === "messages"
                  ? "nav-link nav-active "
                  : "nav-link mt-0"
              }
            >
              <MdOutlineForum className="nav-icon" />
              Messages
            </Link>
            <Link
              to="/transactions/vouchers"
              className={
                activeStyle === "transactions"
                  ? "nav-link nav-active"
                  : "nav-link mt-0"
              }
            >
              <MdOutlineLocalAtm className="nav-icon" />
              Transactions
            </Link>
            <Link
              to="/my-profile/general-info"
              className={
                activeStyle === "myprofile"
                  ? "nav-link nav-active"
                  : "nav-link mt-0"
              }
            >
              <MdOutlinePersonOutline className="nav-icon" />
              My Profile
            </Link>
            <Link
              to="/shop-local-AI/business-profile"
              className={
                activeStyle === "shop-local-AI"
                  ? "nav-link nav-active"
                  : "nav-link mt-0"
              }
            >
              <img
                className="shoplocalAI-Logo"
                src={shoplocalAI}
                alt="shoplocal AI icon"
              />
              CommunityX AI
            </Link>
            {/* independent-pages --> http://localhost:3001/ --> https://dev.communityx.digital/*/}
            <a
              href={`${baseUrl}business/${BusinessSlug}/business-view`}
              target="_blank"
              className="nav-link mt-0"
            >
              <img
                loading="lazy"
                src={MyBusinessProfile}
                alt="MyBusinessProfile"
                className="MyBusinessProfile"
              />
              My Business Profile
            </a>

            {/* end */}
            <a
              className="nav-link-992px user_manual"
              target="_blank"
              href={`${process.env.REACT_APP_DEV_COMMON_URL}support`}
            >
              <img
                src={userManual}
                className="nav-icon"
                width={15}
                height={15}
              />{" "}
              User Manual
            </a>
            <EmailLink
              className="nav-link-992px support_Mail"
              email="support@communityx.digital"
              subject=""
              body=""
            />
            <Link className="nav-link-992px" onClick={LogoutHandler}>
              <MdLogout className="nav-icon" /> Logout
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <a
        className="nav-link user_manual  hide-mobile hide-tab"
        target="_blank"
        href={`${process.env.REACT_APP_DEV_COMMON_URL}support`}
      >
        <img src={userManual} className="nav-icon" width={18} height={18} />{" "}
        User Manual
      </a>
      <EmailLink
        className="nav-link nav-logout hide-mobile hide-tab logouttab support_Mail"
        email="support@communityx.digital"
        subject=""
        body=""
      />
      <Link
        className="nav-link nav-logout hide-mobile hide-tab logouttab"
        onClick={LogoutHandler}
      >
        <MdLogout className="nav-icon" /> Logout
      </Link>
    </div>
  );
};

export default Navigation;
